import { MouseEvent, useState } from 'react';

import {
  FloatingTabContainer,
  PageTabBar,
  TabbedSectionContainer,
  TabView,
} from 'dashboard/components/TabbedSectionV2/shared';
import { Tab } from 'design-system/components/TabBar';

interface TabbedSectionProps {
  tabs: TabView[];
  cardView?: boolean;
  onClick?: (e?: MouseEvent) => void;
  onTabSelect?: (selectedTabIndex: number) => void;
  dataTest?: string;
}

const TabbedSection = ({
  tabs,
  cardView = false,
  onClick,
  onTabSelect,
  dataTest,
}: TabbedSectionProps) => {
  const [selectedTabIdx, setSelectedTabIdx] = useState<number>(0);

  const tabsToRender = tabs.filter(Boolean);

  // If the amount of tabs decrease in a way that makes the current index
  // invalid, reset to having the first tab selected.
  const selectedTabIdxWithFallback = selectedTabIdx < tabsToRender.length ? selectedTabIdx : 0;

  const changeToTab = (tabIndex: number) => {
    setSelectedTabIdx(tabIndex);
    onTabSelect?.(tabIndex);
  };

  return (
    <TabbedSectionContainer data-test={dataTest}>
      {cardView ? (
        <PageTabBar
          id='tabbed-section__tabs-card-body'
          onClick={onClick}
          clickable={onClick ? true : false}
        >
          {tabsToRender.map(({ name, disabled, dataTest: tabDataTest, badge }, idx) => (
            <Tab
              key={name}
              disabled={disabled}
              selected={idx === selectedTabIdxWithFallback}
              onClick={() => !disabled && changeToTab(idx)}
              id={tabDataTest}
              data-test={tabDataTest}
              badge={badge}
            >
              {name}
            </Tab>
          ))}
        </PageTabBar>
      ) : (
        <FloatingTabContainer
          id='tabbed-section__tabs-container'
          onClick={onClick}
          clickable={onClick ? true : false}
        >
          {tabsToRender.map(({ name, disabled, dataTest: tabDataTest, badge }, idx) => (
            <Tab
              key={name}
              disabled={disabled}
              selected={idx === selectedTabIdxWithFallback}
              onClick={() => !disabled && changeToTab(idx)}
              id={tabDataTest}
              data-test={tabDataTest}
              badge={badge}
            >
              {name}
            </Tab>
          ))}
        </FloatingTabContainer>
      )}

      {tabsToRender[selectedTabIdxWithFallback].contents}
    </TabbedSectionContainer>
  );
};

export default TabbedSection;
